import axiosApi from "shared/api/axiosApi";
import { checkCurrentLanguage } from "shared/lib/checkCurrentLanguage";
import { List } from "api/slice/types";
import { CreateProductBody, CreateProductRes, GetProductsParams, GetProductsResponse, GetProductsByMarathonIdParams, GetProductsByMarathonIdResponse, UpdateProductBody, GetProductsByProductIdRes, GetProductsByProductIdParams, GetUserMarathonProductsParams, GetUserMarathonProductsResponse } from "./types";

export const productsApi = {
  getProducts: async (params: GetProductsParams): Promise<GetProductsResponse[]> => {
    const response = await axiosApi.get<GetProductsResponse[]>(
      `/products`,
      {
        params,
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  getUserMarathonProducts: async ({ marathonId, userId }: GetUserMarathonProductsParams): Promise<GetUserMarathonProductsResponse[]> => {
    const response = await axiosApi.get<GetUserMarathonProductsResponse[]>(
      `/products/marathons/${marathonId}/users/${userId}`,
      {
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  getProductsByMarathonId: async ({ marathonId }: GetProductsByMarathonIdParams): Promise<GetProductsByMarathonIdResponse[]> => {
    const response = await axiosApi.get<GetProductsByMarathonIdResponse[]>(
      `/products/marathons/${marathonId}`,
      {
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  getProductByProductId: async (productId: number): Promise<GetProductsByProductIdRes> => {
    const response = await axiosApi.get<GetProductsByProductIdRes>(
      `/products/${productId}`,
      {
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  createProduct: async (body: CreateProductBody): Promise<CreateProductRes> => {
    const response = await axiosApi.post<CreateProductRes>(
      `/products`,
      body,
      {
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  updateProduct: async (
    data: UpdateProductBody
  ): Promise<void> => {
    const response = await axiosApi.put<void>(
      `/products`,
      data,
      {
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  deleteProductByProductId: async (productId: number): Promise<void> => {
    const response = await axiosApi.delete<void>(
      `/products/${productId}`,
      {
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
}